module.exports = __webpack_public_path__ + "img/1-13-4.2681a090.png";